import React from "react";
import { inject, observer } from "mobx-react";
import PropTypes from "prop-types";
import { CardContainer, LightButton } from "best-common-react";
import AdditionalOptions from "./AdditionalOptions";
import { CompConstants } from "../../constants/CompConstants";
import { ReportConstants } from "../../constants/ReportConstants";
import NewTimeFrameModal from "./NewTimeFrameModal";
import TimeFrames from "./TimeFrames";

class StatSummaryComp extends React.Component {
  render() {
    let { compStore, trackingHelper } = this.props.rootStore;
    return (
      <React.Fragment>
        <NewTimeFrameModal tab={CompConstants.TABS.STAT_SUMMARY} />
        <CardContainer>
          <CardContainer.Body>
            <div className="container-fluid">
              <div className="row mx-0">
                <TimeFrames tab={CompConstants.TABS.STAT_SUMMARY} />
                <AdditionalOptions tab={CompConstants.TABS.STAT_SUMMARY} />
              </div>
            </div>
          </CardContainer.Body>
          <CardContainer.Footer>
            <div className="header-item-row">
              <LightButton
                onClick={() => {
                  if ("selStat" !== compStore.comp.reportCriteria.statSummarySortType) {
                    compStore.comp.statSummarySort = compStore.comp.reportCriteria.statSummarySortType;
                  }

                  trackingHelper.trackClickAndRunComp(
                    ReportConstants.REPORT_STATSUMMARY,
                    "Run Stat Summary Report Click"
                  );
                }}
              >
                Run Stat Summary Report
              </LightButton>
            </div>
          </CardContainer.Footer>
        </CardContainer>
      </React.Fragment>
    );
  }
}

StatSummaryComp.propTypes = {
  rootStore: PropTypes.object.isRequired
};

export default inject("rootStore")(observer(StatSummaryComp));
